//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.ComparisonResultBase.js";
let d=[[[0,"ConflictLogicalObject",1,"Mechatronics.LogicObject",0],[0,"LogicalObject",1,"Mechatronics.LogicObject",0],[0,"ResultCategory",1,0],[0,"ResultName",0,0],[0,"ResultType",0,0]],[[[],"Dispose",{},0,0],[["numAttributes","attributes"],"GetAttributes",{},0,0],[["numElectricalParts","electricalParts"],"GetElectricalParts",{},0,0]],[]];
SPLM.Mechatronics.ComparisonResult = class extends SPLM.Mechatronics.ComparisonResultBase{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ComparisonResult";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ComparisonResult.Category = Object.freeze({
    "Create" : "Create", "UpdateAttributes" : "UpdateAttributes", "UpdateParts" : "UpdateParts", "Move" : "Move", "Delete" : "Delete", "CreateConflict" : "CreateConflict", "MoveConflict" : "MoveConflict", "NotFoundConflict" : "NotFoundConflict", "NoAction" : "NoAction"});

export default SPLM;